import * as React from "react";
import { forwardRef } from "react";
const SvgText = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 7V5H19V7M12 5V19M12 19H14M12 19H10", stroke: "#2C2D32", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgText);
export default ForwardRef;
